import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Clipboard from 'v-clipboard'

import App from './App.vue'

Vue.use(Vuetify)
Vue.use(Clipboard)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
